const transformAvalFormData = values => ({
  name: values.name,
  paternalName: values.paternalName,
  maternalName: values.maternalName || undefined,
  rfc: values.rfc,
  curp: values.curp || undefined,
  phone: values.phone,
  email: values.email,
  sex: values.sex,
  nationality: values.nationality,
  address: values.address || undefined,
  exteriorNumber: values.exteriorNumber || undefined,
  interiorNumber: values.interiorNumber || undefined,
  neighborhood: values.neighborhood || undefined,
  city: values.city || undefined,
  state: values.state || undefined,
  zipCode: values.zipCode || undefined,
  municipality: values.municipality || undefined,
  country: values.country || undefined,
  kinship: values.kinship || undefined
});

export default transformAvalFormData;
